import React from 'react'
import LoginForm from '../../components/login-form/LoginForm'
import FloatingIcons from '../../components/floating-icons/FloatingIcons'
import { useBrand } from '../../hooks/useBrand'
import './Login.css'

const Login: React.FC = () => {
    const { brand, isBranded } = useBrand()

    // Names the product in the tab and in browser history, which is where a user
    // with several tabs open actually looks to find this one.
    React.useEffect(() => {
        document.title = isBranded ? `Sign in to ${brand.name}` : 'Sign in | Nextek Systems'
    }, [brand.name, isBranded])

    return (
        <div className="login-page">
            {/* Background decorations */}
            <div className="login-page__bg">
                <div className="login-page__blob login-page__blob--1" />
                <div className="login-page__blob login-page__blob--2" />
                <div className="login-page__blob login-page__blob--3" />
                <div className="login-page__grid" />
            </div>

            {/* Drifting product tiles — the incoming product is brought to the
                front, so the backdrop agrees with the logo on the card. */}
            <FloatingIcons feature={isBranded ? brand.key : null} />

            {/* Soft glow that lifts the card off the busy backdrop */}
            <div className="login-page__spotlight" />

            {/* Content */}
            <div className="login-page__content">
                <LoginForm />
            </div>

            {/* Footer illustration */}
            <div className="login-page__footer">
                <div className="login-page__footer-wave">
                    <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                        <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" fillOpacity="0.5"/>
                        <path d="M0 120L60 115C120 110 240 100 360 95C480 90 600 90 720 92C840 94 960 98 1080 100C1200 102 1320 102 1380 102L1440 102V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" fillOpacity="0.8"/>
                    </svg>
                </div>
                <p className="login-page__copyright">&copy; {new Date().getFullYear()} Nextek Systems. All rights reserved.</p>
            </div>
        </div>
    )
}

export default Login
